﻿'use strict'
import { App, Action } from '../../config/app.js'
import { Modal } from '../../modal.js'
import { i18n, parseBool, hasRole, loadScript, currentStore } from '../../helper.js'

export default function ()
{
	App.Modal.WalletCard = new Modal('WalletCard', {
		onInit: async (modal) =>
		{
			modal.element.addEventListener('click', e =>
			{
				if (!e.target.matches('input[type=checkbox][name=temporary]'))
					return

				const checkDefault = modal.element.querySelector('input[type=checkbox][name*=primary]')
				checkDefault.checked = false
				checkDefault.disabled = e.target.checked ? true : false

				modal.element.querySelector('button[type=submit]').innerText = i18n(
					e.target.checked ? 'common.ok' : 'common.save'
				)
			})
		},
		setSubmitAction: (modal, actionName) =>
		{
			modal.options.actionSubmitName = actionName
			modal.element.setAttribute('ui-action', actionName)
		},
		onOpen: async (modal, data) =>
		{
			if (data.id)
			{
				modal.options.actionSubmitName = 'walletcard update'

				return Promise.all(
					[
						App.Store.fetch('walletcard', data.id, { 'include': 'address.*' }),
						App.Store.fetch('country', 0, { include: 'stateProvince' })
					])
					.then(results =>
					{
						modal.view.model.clear()
						modal.view.model.sync(data)
						modal.view.model.sync(results[0])
					})
			}

			if (!window.Stripe && hasRole('Patient'))
			{
				await loadScript('https://js.stripe.com/v2/')
				Stripe.setPublishableKey(currentStore('stripeApiKey'))
			}

			modal.options.actionSubmitName = 'walletcard create'
			return App.Store.fetch('country', 0, { include: 'stateProvince' })
				.then(() =>
				{
					modal.view.model.clear()
					modal.view.model.sync(data)
					modal.view.render()
				})
		},
		runAction: (modal) => Action.cache(modal.options.apiAction).run(modal.element),
		onActionBefore: async (modal, e) =>
		{
			const now = new Date()
			const expDate = new Date(e.detail.data.attributes.expirationYear, e.detail.data.attributes.expirationMonth)

			if (now > expDate)
			{
				e.preventDefault()
				modal.element.querySelector('[name="attributes[expirationMonth]"]')?.classList.add('input-validation-error')
				modal.element.querySelector('[name="attributes[expirationYear]"]')?.classList.add('input-validation-error')
			}
			else if (!e.detail.data.id && !e.detail.data.attributes.token && hasRole('Patient'))
			{
				e.preventDefault()
				Stripe.card.createToken(
					{
						number: modal.element.querySelector('[name="attributes[number]"]').value,
						cvc: modal.element.querySelector('[name="attributes[cvc]"]').value,
						exp_month: modal.element.querySelector('[name="attributes[expirationMonth]"]').value,
						exp_year: modal.element.querySelector('[name="attributes[expirationYear]"]').value
					},
					(_status, response) =>
					{
						if (response.error)
						{
							App.UI.AlertError(response.error.message)
						}
						else
						{
							modal.element.querySelector('[name="attributes[token]"]').value = response.id
							Action.cache(modal.options.actionSubmitName).run(modal.element)
						}
					})
			}
		},
		onActionAfter: (_modal, e) =>
		{
			if (e.detail.success && parseBool(e.detail.data.attributes.primary))
			{
				// Remove primary marker from other entries
				for (let id in App.Store.model('walletcard'))
				{
					let model = App.Store.model('walletcard', id)
					if (model.id != e.detail.data.id && model.attributes.primary)
					{
						model.attributes.primary = false
					}
				}
			}
		}
	})
}
